import { useState, useEffect } from 'react';
import { BOOKING_URL, BRAND } from '@/constants';

const navLinks = [
  { label: 'Le cabinet', href: '#a-propos' },
  { label: 'La thérapie', href: '#cupping' },
  { label: 'Bienfaits', href: '#bienfaits' },
  { label: 'Tarifs', href: '#tarifs' },
  { label: 'Avis', href: '#avis' },
  { label: 'Nous trouver', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#04160f]/95 backdrop-blur-md shadow-lg shadow-black/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1180px] mx-auto px-6 flex items-center justify-between h-[84px]">
        <a
          href="#accueil"
          onClick={(e) => {
            e.preventDefault();
            handleNav('#accueil');
          }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src={BRAND.logoUrl}
            alt={BRAND.name}
            className="h-[62px] w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(link.href);
              }}
              className="text-sm font-medium tracking-wide text-[#f2ede2] hover:text-[#8fd6b8] transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
          <a
            href={BOOKING_URL}
            className="inline-flex items-center gap-2 bg-[#0b6b52] hover:bg-[#0a5a45] text-white text-sm font-semibold px-[22px] py-[11px] rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            Demander RDV
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-[#f2ede2]"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#04160f] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(link.href);
              }}
              className="text-[#f2ede2] font-medium text-sm py-1 cursor-pointer hover:text-[#8fd6b8] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href={BOOKING_URL}
            onClick={() => setMenuOpen(false)}
            className="bg-[#0b6b52] text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center hover:bg-[#0a5a45] transition-colors cursor-pointer"
          >
            Demander RDV
          </a>
        </div>
      )}
    </nav>
  );
}
